import {BaseContainerBlockModel} from '../../model/block/base-container-block.model';
import {BlockModel} from '../../model/block/block.model';

export function isContainerBlock(block: BlockModel): block is BlockModel<BaseContainerBlockModel> {
  return block.data instanceof BaseContainerBlockModel;
}